"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var UserBlockSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M10.8578024,6.74209124 C10.9495406,6.51263337 11,6.2622094 11,6 C11,4.8954305 10.1045695,4 9,4 C7.8954305,4 7,4.8954305 7,6 C7,6.74028236 7.40219863,7.38662619 8,7.73243561 L8,9.12601749 C6.27477279,9.57006028 5,11.1361606 5,13 L5,14 L8,14 L8,15 L5,15 C4.44771525,15 4,14.5522847 4,14 L4,13 C4,10.8948158 5.30102603,9.09350251 7.14289226,8.35624595 C6.44680015,7.80685854 6,6.95560715 6,6 C6,4.34314575 7.34314575,3 9,3 C10.6568542,3 12,4.34314575 12,6 C12,6.34864246 11.9405277,6.68339441 11.8311745,6.99466433 C11.3075066,6.87680161 11.3075066,6.87680161 10.8578024,6.74209124 Z M12.5,15 C10.5670034,15 9,13.4329966 9,11.5 C9,9.56700338 10.5670034,8 12.5,8 C14.4329966,8 16,9.56700338 16,11.5 C16,13.4329966 14.4329966,15 12.5,15 Z M13.8786949,9.41419827 C13.4834784,9.15243838 13.0095412,9 12.5,9 C11.1192881,9 10,10.1192881 10,11.5 C10,12.0095412 10.1524384,12.4834784 10.4141983,12.8786949 L13.8786949,9.41419827 Z M14.5858017,10.1213051 L11.1213051,13.5858017 C11.5165216,13.8475616 11.9904588,14 12.5,14 C13.8807119,14 15,12.8807119 15,11.5 C15,10.9904588 14.8475616,10.5165216 14.5858017,10.1213051 Z" })));
};
UserBlockSmall.displayName = 'UserBlockSmall';
exports.default = UserBlockSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=UserBlockSmall.js.map